import { render } from "./SzPageLayout.vue?vue&type=template&id=5a61f011&scoped=true"
import script from "./SzPageLayout.vue?vue&type=script&lang=ts"
export * from "./SzPageLayout.vue?vue&type=script&lang=ts"

import "./SzPageLayout.vue?vue&type=style&index=0&id=5a61f011&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-5a61f011"

export default script